export const FETCH_ALARM = 'views/users/FETCH_ALARM'